module.exports = __webpack_public_path__ + "static/img/logo.d1b90fdf.png";